import { motion } from "motion/react";

const TICKER_TEXT =
  "✨ NEW: AI Intent Mapping v2.0 is now live! — Claim 15% Launch Discount →   🚀 Track your AI citations across ChatGPT, Perplexity & Google AI Overviews —   🎯 GEO Optimization now available for all plans →   ⚡ Join hundreds of marketers ranking in AI search —   ";

export const TopBanner = () => {
  return (
    <motion.div
      initial={{ y: -40 }}
      animate={{ y: 0 }}
      className="fixed top-0 left-0 w-full bg-[#FF2F2F] text-white z-[100] overflow-hidden shadow-lg"
      style={{ height: "36px" }}
    >
      <style>{`
        @keyframes marquee-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .marquee-track {
          display: flex;
          white-space: nowrap;
          animation: marquee-scroll 28s linear infinite;
          will-change: transform;
        }
        .marquee-track:hover { animation-play-state: paused; }
      `}</style>

      <div className="h-full flex items-center overflow-hidden">
        <div className="marquee-track">
          <span className="text-xs sm:text-sm font-bold tracking-tight px-4">{TICKER_TEXT}</span>
          <span className="text-xs sm:text-sm font-bold tracking-tight px-4">{TICKER_TEXT}</span>
        </div>
      </div>
    </motion.div>
  );
};
